import { useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const getTenant = (state) => {
  return state.auth.user?.tenant || localStorage.getItem("kinesin-tenant");
};

export const useGetPermissions = () => {
  const tenantVal = useSelector(getTenant);

  return useQuery({
    queryKey: ["permissions", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/permission`);
      return response.data;
    },
    enabled: !!tenantVal,
  });
};

export const useGetStaffPermissions = (staffMemberId) => {
  const tenantVal = useSelector(getTenant);

  return useQuery({
    queryKey: ["staffPermissions", tenantVal, staffMemberId],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/staffpermission/getbystaffmemberid/${staffMemberId}`
      );
      return response.data;
    },
    enabled: !!tenantVal && !!staffMemberId,
    staleTime: 0,
  });
};

export const useAssignPermission = () => {
  const tenantVal = useSelector(getTenant);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ staffMemberId, permissionId }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/staffpermission`,
        { staffMemberId, permissionId }
      );
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["staffPermissions", tenantVal, variables.staffMemberId],
      });
    },
  });
};

export const useRemovePermission = () => {
  const tenantVal = useSelector(getTenant);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, staffMemberId, permissionId }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.delete(
        `${tenantVal}/staffpermission/delete`,
        { data: { id, staffMemberId, permissionId } }
      );
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["staffPermissions", tenantVal, variables.staffMemberId],
      });
    },
  });
};
